<template>
  <button type="button" class="action-row" @click="$emit('select')">
    <span class="action-row__title">{{ title }}</span>
    <span class="material-icons action-row__chevron">chevron_right</span>
  </button>
</template>

<script setup lang="ts">
defineProps<{ title: string }>();
defineEmits<{ (e: "select"): void }>();
</script>

<style scoped lang="scss">
.action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.1rem 0.25rem;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--gray-border, #434343);
  color: inherit;
  text-align: left;
  cursor: pointer;

  &:first-child {
    border-top: 1px solid var(--gray-border, #434343);
  }

  &__title {
    font-size: 1.05rem;
    font-weight: 600;
  }

  &__chevron {
    color: var(--text-muted, #b2b2b2);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
}
</style>
